import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';
import total_hour from '../images/totalhours.png'
import active_member from "../images/members.png"
import total_member from "../images/group.png"
import blocked_user from "../images/block-user.png"
import add_user from "../images/add-group.png"

export default function User_management() {
    const navigate = useNavigate();
    const [listMembersArray, setListMembersArray] = useState([]);
    const [stats, setStats] = useState({});
    const [selectedMember, setSelectedMember] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        let com_id = localStorage.getItem('mem_company_id');
        var obj = {
            com_id: com_id
        };

        console.log(obj);

        fetch('getAllCompanyMember.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // ✅ auto JSON parse
            .then(res => {
                console.log(res);

                if (res !== 'fail' && res) {
                    // ensure it's an array
                    if (Array.isArray(res)) {
                        let len = res.length;

                        if (len < 1) {
                            showAlert('Cannot find any member.');
                            setListMembersArray([]);
                        } else {
                            setListMembersArray(res);
                        }
                    } else {
                        setListMembersArray([]);
                    }
                } else {
                    showAlert('Cannot find any member.');
                    setListMembersArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                setListMembersArray([]);
            });
    }, [])

    useEffect(() => {
        let com_id = localStorage.getItem('mem_company_id');
        fetch('getUserManagementStats.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                com_id: com_id
            })
        })
            .then(response => response.json())
            .then(res => {
                console.log(res);
                setStats(res);
            })
            .catch(error => {
                console.log(error);
            });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function getmemberdetails(e) {
        let member_id = e.target.value;
        if (member_id === '') {
            setSelectedMember(null);
            return;
        }
        fetch('getMemberManagementDetails.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                member_id: member_id
            })
        })
            .then(response => response.json())
            .then(res => {
                console.log(res);
                setSelectedMember(res);
            })
            .catch(error => {
                console.log(error);
            });
    }

    function blockUser(id) {
        const formData = new FormData();
        formData.append('pr_key', id);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('blockUser.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.status === 'success') {
                    showAlert("User blocked successfully");
                    navigate('/redirect_usersetting');

                } else {
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Image upload failed");
            });
    }

    function unblockUser(id) {
        const formData = new FormData();
        formData.append('pr_key', id);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('unblockUser.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    showAlert("User un-blocked successfully");
                    navigate('/redirect_usersetting');
                   

                } else {
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Image upload failed");
            });
    }

    function removeMem(id) {
        var obj = {
            primary_key: id
        }
        
        $.ajax({
            type: 'POST',
            url: 'removeComMem.php',
            data: obj,
            cache: false,
            success: function (result) {
                

                if (result != 'fail') {
                    showAlert('Removed successfully');
                    navigate('/redirect_usersetting');
                } else {
                    showAlert('Cannot remove member.');
                }
            },
        });
    }

    function restoreuser(id) {
         var obj = {
            primary_key: id
        }
        
        $.ajax({
            type: 'POST',
            url: 'restoreComMem.php',
            data: obj,
            cache: false,
            success: function (result) {
                

                if (result != 'fail') {
                    showAlert('Restore member successfully');
                    navigate('/redirect_usersetting');
                } else {
                    showAlert('Cannot remove member.');
                }
            },
        });
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
           <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>
                        User Management
                    </h2>

                    <p className='fullwidth pull_left pb-30'>
                        This page shows the overall activity and performance of your company members.
                    </p>
                </div>
                <div className='fullwidth'>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_one_fourth'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={total_member} alt="Total hour" />
                                </div>
                                <h3>Total Members</h3>
                                <span>Total number of members </span>
                                <p className='highlightfont'>{stats.total_members}</p>
                            </div>
                        </div>

                        <div className='vl_dsh_one_fourth'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={active_member} alt="Total hour" />
                                </div>
                                <h3>Active Members</h3>
                                <span>Total number of active members </span>
                                <p className='highlightfont'>{stats.active_members}</p>
                            </div>
                        </div>

                        <div className='vl_dsh_one_fourth'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={blocked_user} alt="Total hour" />
                                </div>
                                <h3>Blocked Members</h3>
                                <span>Total number of blocked members </span>
                                <p className='highlightfont'>{stats.blocked_members}</p>
                            </div>
                        </div>

                        <div className='vl_dsh_one_fourth'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={add_user} alt="Total hour" />
                                </div>
                                <h3>New This Month</h3>
                                <span>New members joined this month </span>
                                <p className='highlightfont'>{stats.new_members}</p>
                            </div>
                        </div>

                    </div>
                    <div className='fullwidth pull_left pt-24'>
                        <div className='pro_dropdown'>
                            <select onChange={getmemberdetails}>
                                <option value=''>
                                    Select Member
                                </option>
                                {
                                    listMembersArray.map((item, index) => (
                                        <option key={index} value={item.primary_key}>
                                            {item.mem_fname} {item.mem_lname}
                                        </option>
                                    ))
                                }

                            </select>
                        </div>
                        <div className='vl_listing_area'>
                            <table className='vl_task_table'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Role</th>
                                        <th>Projects</th>
                                        <th>Hour</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        selectedMember &&
                                        <tr>
                                            <td>
                                                {selectedMember.member.mem_fname} {selectedMember.member.mem_lname}
                                            </td>
                                            <td>
                                                {selectedMember.member.mem_role}
                                            </td>
                                            <td>
                                                {
                                                    selectedMember.projects.length > 0 ?

                                                        selectedMember.projects.map((item, index) => (
                                                            <span
                                                                key={index}
                                                                className='project_badge'
                                                                title={item.project_status}
                                                            >
                                                                {item.proname}
                                                            </span>
                                                        ))

                                                        :

                                                        'No Project'
                                                }

                                            </td>
                                            <td>
                                                {selectedMember.total_hours || '00:00:00'}
                                            </td>
                                            <td>
                                                {
                                                    selectedMember.member.block_user !== 'yes' ?

                                                        <button title="Block User" className="rightgap backtranparent blockbtn" onClick={() => blockUser(selectedMember.member.id)}><i className="ri-lock-line"></i></button>
                                                        :
                                                        <button title="Un-Block User" className="rightgap backtranparent greenicon unblockbtn" onClick={() => unblockUser(selectedMember.member.id)}>
                                                            <i className="ri-lock-unlock-line"></i></button>
                                                }

                                                {
                                                    selectedMember.member.delete_user !== 'yes' ?

                                                        <button className="rightgap" onClick={() => removeMem(selectedMember.member.id)} >  <i className='ri-delete-bin-3-fill'></i></button>
                                                        :
                                                        <button className="rightgap" onClick={() => restoreuser(selectedMember.member.id)} title="Restore Member"><i className='ri-arrow-go-back-line'></i></button>
                                                }
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
